import * as React from 'react'

import { ActionButton } from 'uiComponents/buttons'
import { ModalDialog, ModalDialogTitle, NavigationSection } from 'uiComponents/popups/modal'
import { LoaderWrapper } from 'uiComponents/loaders'
import { SingleSelectOption } from 'uiComponents/input'
import { ReservationPoolForm, reservationPoolValidationSchema } from './_shared/form'
import { FormWrapper } from 'uiComponents/form/form'
import { useTranslation } from 'translations'

interface DialogProps {
    accountSlug: string
    loading: boolean
    retailerOptions: SingleSelectOption[]
    onCancel: () => void
    onConfirm: (name: string, retailer: string, isScannable: boolean) => void
}

export function AddNewPoolDialog(props: DialogProps) {
    const { t } = useTranslation()
    return (
        <ModalDialog onDismiss={props.onCancel} interactive fromTop="20%">
            <LoaderWrapper loading={props.loading}>
                <div style={{ width: '25em' }}>
                    <ModalDialogTitle>{t('venue.bookingCodes.reservationCodePools.addNewPool.title')}</ModalDialogTitle>
                    <FormWrapper
                        initialValues={{
                            name: undefined,
                            externalChannel: undefined,
                        }}
                        onSubmit={(values) => {
                            props.onConfirm(values.name as string, values.externalChannel, values.isScannable)
                        }}
                        validationSchema={reservationPoolValidationSchema}
                    >
                        <ReservationPoolForm accountSlug={props.accountSlug} retailerOptions={props.retailerOptions} />
                        <NavigationSection>
                            <ActionButton size="large" secondary onClick={props.onCancel}>
                                {t('common.cancel')}
                            </ActionButton>
                            <ActionButton type="submit" id="add-new-res-codes-pool-button" size="large">
                                {t('common.save')}
                            </ActionButton>
                        </NavigationSection>
                    </FormWrapper>
                </div>
            </LoaderWrapper>
        </ModalDialog>
    )
}
